import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { selectMap } from "../features/counter/counterSlice";
import useAppModernisation from "../hooks/useAppModernisation";
import { setGlobalBackHandler } from "../hooks/useGlobalBackTrap";
import { parseMapToDOM } from "../utils/index";

const useGoBack = () => {
    const navigate = useNavigate();
    const { isAppMode } = useAppModernisation();
    const currentMap = useSelector(selectMap);

    useEffect(() => {
        setGlobalBackHandler(goBack);
        return () => setGlobalBackHandler(null);
    }, [currentMap]);

    const goBack = () => {
        if (isAppMode) {
            // Parse the current map to DOM
            const xmlParsed = parseMapToDOM(currentMap);
            const activeElm = xmlParsed.querySelectorAll(
                "[class*='active']:not(ditatitle)",
            );

            const elmFilter = [...activeElm].filter(
                (el) => el.getAttribute("level") < 2,
            );

            if (elmFilter.length > 0) {
                const active = elmFilter[elmFilter.length - 1];
                let prePath = active.getAttribute("href").replace(".dita", "");
                if (
                    active.getAttribute("level") === "0" &&
                    active.tagName === "chapter"
                ) {
                    prePath = active.getAttribute("href").split("/")[0];
                }
                if (prePath.includes("/c_") || prePath.includes("/tandf")) {
                    const pathArray = prePath.split("/");
                    pathArray.pop();
                    prePath = pathArray.join("/");
                }
                const href = "/app/nav/" + prePath;
                window.location.href = href;
            } else {
                navigate(-1);
            }
        } else {
            navigate(-1);
        }
    };

    return { goBack };
}
export default useGoBack;